import chalk from 'chalk';
const colors = {
    DEBUG: chalk.cyan,
    INFO: chalk.blue,
    WARN: chalk.yellow,
    ERROR: chalk.red
};
export class ConsoleTransport {
    constructor(options = {}) {
        var _a, _b;
        this.options = options;
        this.lastLogTime = 0;
        this.id = ConsoleTransport.id;
        const { debug = window.console.debug, info = window.console.info, warn = window.console.warn, error = window.console.error } = (_a = options.displayFunctions) !== null && _a !== void 0 ? _a : {};
        this.debugFn = debug;
        this.infoFn = info;
        this.warnFn = warn;
        this.errorFn = error;
        this.startTime = performance.now();
        this.stringifyJson = (_b = options.stringifyJson) !== null && _b !== void 0 ? _b : false;
    }
    log(loggerName, level, ...args) {
        const time = this.getLogTime();
        const levelUpper = level.toUpperCase();
        const prefix = `${chalk.gray(time)} ${chalk.green(loggerName)} ${colors[levelUpper](levelUpper)}:`;
        if (args.length && typeof args[0] === 'string') {
            // concat prefix with first argument to support string substitutions
            args[0] = `${prefix} ${args[0]}`;
        }
        else {
            args.unshift(prefix);
        }
        if (this.stringifyJson) {
            for (let arg = 1; arg < args.length; arg += 1) {
                if (typeof args[arg] === 'object') {
                    try {
                        const str = JSON.stringify(args[arg]);
                        if (str) {
                            args[arg] = str;
                        }
                    }
                    catch (_a) {
                        // Do nothing if can't convert it
                    }
                }
            }
        }
        let method;
        if (level === 'error') {
            method = this.errorFn;
        }
        else if (level === 'warn') {
            method = this.warnFn;
        }
        else if (level === 'info') {
            method = this.infoFn;
        }
        else {
            method = this.debugFn;
        }
        method(...args);
    }
    getLogTime() {
        const { timeFormat = 'absolute' } = this.options;
        if (timeFormat === 'absolute') {
            const date = new Date();
            const toSeconds = date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
            const ms = date.getMilliseconds();
            return `${toSeconds} ${ms}ms`;
        }
        const nowPrecise = performance.now();
        if (timeFormat === 'start-ms') {
            // relative since the transport was created
            const diff = (nowPrecise - this.startTime).toFixed(3);
            return `${diff}ms`;
        }
        // relative since the last log message
        if (this.lastLogTime === 0) {
            this.lastLogTime = nowPrecise;
            return `0ms`;
        }
        const diff = (nowPrecise - this.lastLogTime).toFixed(3);
        this.lastLogTime = nowPrecise;
        return `+${diff}ms`;
    }
}
ConsoleTransport.id = Symbol('Console');
